import { render, staticRenderFns } from "./comp_Title.vue?vue&type=template&id=9a06e70c&scoped=true&"
import script from "./comp_Title.vue?vue&type=script&lang=js&"
export * from "./comp_Title.vue?vue&type=script&lang=js&"
import style0 from "./comp_Title.vue?vue&type=style&index=0&id=9a06e70c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a06e70c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VRow})
